import React, { Component } from "react"
import { connect } from 'react-redux'

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from "@material-ui/core/TablePagination";
import { msg } from '../../components/Notifications/MsgBox';

import {
    getAssetModalAction,
} from '../../redux/actions/MasterAction'
import utilityHelper from "../../helpers/helperUtil";


class SearchAssetModal extends Component {

    constructor(props) {
        super(props)

        this.state = {
            // ...props,
            q_searchAsset: "",
            q_isDummy: "",
            q_offset: 1,
            q_limit: 10,
            assetDatas: [],
            page: 0,
            rowsPerPage: 5,
            totalRecord:0,
            order: "asc",
            orderBy: "",
        }
        this.handleClick = this.handleClick.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.selecctAsset = this.selecctAsset.bind(this)

    }

    selecctAsset(obj){
        window.$('#searchAssetModal').modal('hide')
        this.props.onSelecctAsset(obj.maiN_ASSET_NUMBER)
    }

    handleChange(event) {
        const { name, value } = event.target
        this.setState({
            [name]: value,
        })
    }

 handleClick(event, newPage){
        let assets=[]
        let {q_searchAsset,q_isDummy,page,rowsPerPage} = this.state;
        const {withDummy,t_NEW_ASSET}=this.props

        let dummyAssets=[]
        let totalRecord=0

        if(newPage)
        {
            page = newPage
        }else{
            page = 0
        }
 
     this.props.getAsset(q_searchAsset,q_isDummy,page*rowsPerPage,rowsPerPage)
        .then(response => {
            if(response.data != null){
                assets=response.data

                if(assets && assets.length>0){
                totalRecord+=utilityHelper.parseInt(assets[0].totaL_ROW)
                }
            }

            if(withDummy){

            if(t_NEW_ASSET){
                dummyAssets=t_NEW_ASSET.map((item,index)=>{
                    return {
                        asseT_SUB_NUMBER: item.asset_sub_grouping,
                        description : item.asset_description_1,
                        maiN_ASSET_NUMBER: item.asset_no,
                        totaL_ROW:null
                    }
                })

                if(q_searchAsset && q_searchAsset.length>0){
                    dummyAssets=dummyAssets.filter(f=>(f.maiN_ASSET_NUMBER 
                        && f.maiN_ASSET_NUMBER.toLowerCase().indexOf(q_searchAsset.toLowerCase())!=-1)
                    || f.description && f.description.toLowerCase().indexOf(q_searchAsset.toLowerCase())!=-1)
                }
                
                assets=[...dummyAssets,...assets]
                totalRecord+=utilityHelper.parseInt(t_NEW_ASSET.length)
            }

            if(totalRecord==0){
                msg.error("ไม่พบข้อมูล")
            }
        }

                this.setState({
                    assetDatas:assets,
                    totalRecord:totalRecord,
                    page:page,
                })
        });    
    }
    // Grid start

    desc(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    stableSort(array, cmp) {
        if (typeof (array) !== "undefined") {
            const stabilizedThis = array.map((el, index) => [el, index]);
            stabilizedThis.sort((a, b) => {
                const order = cmp(a[0], b[0]);
                if (order !== 0) return order;
                return a[1] - b[1];
            });
            return stabilizedThis.map(el => el[0]);
        }
    }

    getSorting(order, orderBy) {
        return order === "desc"
            ? (a, b) => this.desc(a, b, orderBy)
            : (a, b) => -this.desc(a, b, orderBy);
    }

    handleRequestSort(event, property) {
        const isDesc = this.state.orderBy === property && this.state.order === "desc";
        this.setState({
            order: isDesc ? "asc" : "desc",
            orderBy: property
        })
    }

    async handleChangePage(event, newPage) {
        await this.setState({
            page: newPage
        })
        this.handleClick(event, newPage)
    }

    async handleChangeRowsPerPage(event) {
        await this.setState({
            rowsPerPage: event.target.value,
            page: 0
        })
        this.handleClick()
    }

    // Grid end

    render() {
        let {assetDatas, q_searchAsset, page, rowsPerPage, totalRecord,order,orderBy} = this.state

        return (
            <div className="modal fade sp-modal rrs-modal" id="searchAssetModal" tabIndex={-1} role="dialog" aria-labelledby="searchAssetModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchAssetModalLabel">ค้นหาข้อมูล Asset</h5>
                            <button type="button" className="close" onClick={()=>window.$('#searchAssetModal').modal('hide')} aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body rrs-container" style={{paddingTop:"10px"}}>
                            <div className="rrs-detail3">
                                <div className="row" style={{paddingBottom:"10px"}}>
                                    <div className="col-7">
                                        <div className="rrs-form">

                                            <label htmlFor="txtEmpCode" className="rrs-label">Asset</label>
                                            <div className="rrs-detail-data">
                                                <input type="text" className="form-control form-control-search-2 w-500"  placeholder="Asset" id="q_searchAsset" name="q_searchAsset"  onChange={this.handleChange} value={q_searchAsset} />
                                            </div>

                                        </div>
                                    </div>
                                   
                                    <div className="col-3">
                                        <div className="rrs-form">
                                            <label htmlFor="txtName" className="rrs-label" style={{marginBottom:'9px',width:'100%'}}>&nbsp;</label>
                                            <button className="rrs-btn-icon" onClick={this.handleClick}><i className="icon bt-search icon-xs"></i></button>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div className="row no-gutters sp-table-content">
                                <div className="col-12">
                                    
                                    <Table aria-labelledby="tableTitle" className="sp-table table rrs-table">
                                        <TableHead>
                                            <TableRow className="sp-table-header">
                                                <TableCell className="th-table text-center">
                                                    รหัส Asset
                                                </TableCell>
                                                <TableCell className="th-table text-center">
                                                    ชื่อ Asset
                                                </TableCell>
                                                <TableCell className="th-table text-center">
                                                    
                                                </TableCell>
                                                
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.stableSort(assetDatas, this.getSorting(this.state.order, this.state.orderBy))
                                                //.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map((row, index) => {
                                                    //console.log("SearchAssetModal", page)                                                    
                                                    //console.log(assetDatas)                                                    
                                                    return (
                                                        <TableRow
                                                            hover
                                                            tabIndex={-1}
                                                            key={"asset_" + index + "_" + row.maiN_ASSET_NUMBER}
                                                        >
                                                            <TableCell className="action-icon">
                                                                {row.maiN_ASSET_NUMBER}
                                                            </TableCell>
                                                            <TableCell className="action-icon text-left">
                                                                {row.description}
                                                            </TableCell>
                                                            <TableCell className="action-icon">
                                                                <button className="btn btn-info btn-choose-item" aria-label="Close" onClick={() => this.selecctAsset(row)}>
                                                                    เลือก
                                                                </button> 
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })
                                            }
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        className="pager"
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={totalRecord}
                                        rowsPerPage={this.state.rowsPerPage}
                                        page={this.state.page}
                                        backIconButtonProps={{
                                            "aria-label": "previous page"
                                        }}
                                        nextIconButtonProps={{
                                            "aria-label": "next page"
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </div>

                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

const mapStateToProps = state => {
    const { MainRedux } = state
    return {
        t_NEW_ASSET : MainRedux.t_NEW_ASSET
    }
}
  
  const mapDispatchToProps = dispatch => {
    return {
        getAsset: (searchAsset,isDummy,offset,limit) => dispatch(getAssetModalAction(searchAsset,isDummy,offset,limit)),
    }
  }
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(SearchAssetModal)